import 'select-woo';
import 'select-woo/dist/css/select2.css';
import '@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.css';

const selectAllVal = 'all';
const selectAllSelector = '.select2.select-all';

export default function init(): void {
	// initialize select2 on each of them and set the hidden input label for ADA compliance.
	setupMultiSelects();
	setupSelectAllOption();

	$('form').on('select2:select', '.select2.select-all', trySelectAll);
}

export function setupMultiSelect(elementOrSelector: string | HTMLSelectElement): void {
	const el = $(elementOrSelector as unknown)[0] as HTMLSelectElement;
	if (!el) return;

	const placeHolder = $(el).attr('placeholder');
	if (placeHolder) {
		el.dataset.placeholder = placeHolder;
	}
	const selectEl = $(el).selectWoo()[0];
	setHiddenInputAriaLabel(selectEl);
	$(el).children('option').attr('aria-role', 'none');
}

export function setupMultiSelects(): void {
	// find all of the select elements that should be multi-select
	const multiSelects = document.querySelectorAll('select[multiple]');
	// initialize select2 on each of them and set the hidden input label for ADA compliance.
	multiSelects.forEach((el) => setupMultiSelect(el as HTMLSelectElement));
}

function setHiddenInputAriaLabel(el: HTMLElement) {
	// get the label associated to the select.
	const selectLabel = $('main').find(`label[for="${el.id}"]`)[0];
	const ariaLabelledByAttr = $(el).attr('aria-labelledby');

	const hiddenTextInput = $(el).siblings('.select2-container').find('input.select2-search__field')[0];

	if (!selectLabel) {
		if (ariaLabelledByAttr == null || ariaLabelledByAttr.length == 0) {
			throw new Error(`No label was found for the #${el.id} multi-select element.`);
		} else {
			hiddenTextInput.setAttribute('aria-labelledby', ariaLabelledByAttr);
		}
	} else {
		// add an id to the label so that we can reference it with aria.
		selectLabel.id = `${el.id}-label`;
		// find the hidden text-input and set aria-labeled-by on it.
		hiddenTextInput.setAttribute('aria-labelledby', selectLabel.id);
	}
}

export function tryPreselectOption(...multiSelects: HTMLSelectElement[]) {
    for(let multiSelect of multiSelects) {
        const opts = Array.from(multiSelect.options);

        if(opts.length === 1 && opts[0].value !== selectAllVal) {
            $(multiSelect).val(opts[0].value);
            $(multiSelect).trigger('change');
        }
    }
}

function setupSelectAllOption() {
	const multiSelects = document.querySelectorAll(selectAllSelector);
	
	for(const multiSelect of multiSelects) {
		const selectAllOption = new Option('Select All', selectAllVal, false, false);
		if ($(multiSelect).find('option[value="all"]').length == 0) {
			$(multiSelect).prepend(selectAllOption);
		}
	}
}

function trySelectAll(ev: JQuery.ChangeEvent) {
	let selection = (ev as any).params.data.id;
	let allOptions = Array.from(($(ev.currentTarget)[0] as HTMLSelectElement).options).map(x => x.value).filter(x => x !== selectAllVal);
	
	if(selection === selectAllVal) {
		$(ev.currentTarget).val(null);
		$(ev.currentTarget).val(allOptions);
		$(ev.currentTarget).trigger('change');
	}
}